module.exports = __webpack_public_path__ + "30def9d8c7d2e19dd58e1911cf9141e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/plaisirs-gastronomiques2/01.jpg
// module id = kk6I
// module chunks = 0